import * as React from 'react';
import PopupButtons from './PopupButtons';
import GenericBenchmarkEditor from './pricing/GenericBenchmarkEditor';
const BenchmarkPopup = ({ data, hasOverride, save }) => {
    const [value, setValue] = React.useState(data?.override?.pricing?.spread?.benchmark ?? data?.override?.pricing?.spread?.benchmark);
    const onChangeValue = React.useCallback((event) => {
        setValue(event.target.value);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericBenchmarkEditor, { value: value, onChange: onChangeValue }),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(PopupButtons, { hasOverride: hasOverride, save: save, value: value, isDisabled: false }))));
};
export default BenchmarkPopup;
